import { SyntheticEvent } from 'react';
import NoImage, { NoImageBig } from './noimage/noimage';

const onPreviewLoadError = (
    e: SyntheticEvent<HTMLImageElement, Event>,
    src?: string,
    shouldUseBigNoImage?: boolean
) => {
    const imgElement = e.currentTarget as HTMLImageElement;

    const placeholderToUse = shouldUseBigNoImage ? NoImageBig : NoImage;

    if (imgElement.src?.toLowerCase() === src?.toLowerCase()) {
        imgElement.src = placeholderToUse;
    } else {
        imgElement.src = src?.toLowerCase() || placeholderToUse;
    }
};

export default onPreviewLoadError;
